import { render, staticRenderFns } from "./loginRe.vue?vue&type=template&id=19509d94&"
import script from "./loginRe.vue?vue&type=script&lang=js&"
export * from "./loginRe.vue?vue&type=script&lang=js&"
import style0 from "./loginRe.vue?vue&type=style&index=0&id=19509d94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports